import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {Dot} from '@/map/components/Overlay';
import {MAP_LAYER_Z_INDEX} from '@/map/constants';
import {distanceToString} from '@/map/utils';
import {interceptProps} from '@/styled-components';
import {palette} from '@/styles';
import {Marker} from '../../Overlay';

interface IProps extends naver.maps.MarkerOptions, IContentProps {}

interface IContentProps {
  distance?: number;
  borderColor?: string;
  textColor?: string;
}

export const MileStone = ({
  distance,
  borderColor = palette.teal200,
  textColor,
  ...props
}: IProps) => {
  return (
    <>
      <Marker {...props} draggable={false} clickable={false}>
        <Dot borderWidth={4} borderColor={borderColor} />
      </Marker>
      <Marker
        {...props}
        clickable={false}
        draggable={false}
        zIndex={MAP_LAYER_Z_INDEX.MAP_CURSOR - 1}
      >
        <Content
          distance={distance}
          borderColor={borderColor}
          textColor={textColor ?? borderColor}
        />
      </Marker>
    </>
  );
};

const Content = ({distance, textColor, borderColor}: IContentProps) => {
  return (
    <Root>
      <Body color={textColor} borderColor={borderColor}>
        {distanceToString(distance || 0)}
      </Body>
    </Root>
  );
};

const Body = styled(Typography)
  .withConfig({
    shouldForwardProp: interceptProps(['borderColor']),
  })
  .attrs({
    variant: 'medium10',
    as: 'div',
  })<{
  borderColor?: string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, calc(-100% - 7px));
  padding: 2px 4px;
  background-color: ${palette.white};
  border-radius: 5px;
  pointer-events: none;
  ${({borderColor}) => borderColor && `border: solid 1px ${borderColor};`}
`;

const Root = styled.div`
  position: relative;
  top: 0;
  left: 0;
`;
